import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";

export function selector(message: Message) {
  return message.details?.type === "join";
}

export { default } from "./MessageJoin.vue";
